import { Box, Button, Heading, VStack } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import InputImage from "components/Atomos/Form/Elements/InputImage";
import { InputText } from "components/Atomos/Form/Elements/InputText";
import { InputTextArea } from "components/Atomos/Form/Elements/InputTextArea";
import ComplaintTypeSelect from "components/Organismos/ComplaintTypeSelect";
import { Map } from "components/Organismos/Map";
import L, { LatLng } from 'leaflet';
import { ComplaintFormData, complaintSchema } from "models/complaint.model";
import { FormComponentProps } from "models/loginForm";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Marker, TileLayer } from "react-leaflet";
import complaintPin from '_assets/imgs/mapa/map-icon-red.png';

type ComplaintFormProps = FormComponentProps<ComplaintFormData> & {
    latitude: number;
    longitude: number;
}

const complaintIcon = L.icon({
    iconUrl: complaintPin,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const ComplaintForm = ({
    latitude,
    longitude,
    onSuccess,
    onFailed
}: ComplaintFormProps) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { control, register, formState: { errors }, handleSubmit } = useForm<ComplaintFormData>({
        resolver: yupResolver(complaintSchema)
    })

    const onSubmit = async (data: ComplaintFormData) => {
        try {
            setIsSubmitting(true);
            await onSuccess(data);
        } catch (err) {
            onFailed?.(err);
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <Box w="full">
            <VStack align="flex-start" as="form" spacing={4} p={6} onSubmit={handleSubmit(onSubmit)}>
                <Heading>Criar manifestação</Heading>
                <Map
                    zoom={15}
                    center={new LatLng(latitude, longitude)}
                    style={{ height: 200 }}
                    zoomControl={false}
                    scrollWheelZoom={false}
                    dragging={false}
                >
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker icon={complaintIcon} position={new LatLng(latitude, longitude)} />
                </Map>
                <InputText
                    name="title"
                    label="Título"
                    w="full"
                    register={register}
                    error={errors?.title}
                />
                <InputTextArea
                    name="description"
                    label="Descrição"
                    w="full"
                    register={register}
                    error={errors?.description}
                />

                <ComplaintTypeSelect
                    name="type"
                    label="Tipo de manifestação"
                    w="full"
                    control={control}
                    error={errors?.type}
                />

                <InputImage
                    name="photo"
                    label="Foto"
                    w="full"
                    control={control}
                    error={errors?.photo}
                />

                <Button isFullWidth colorScheme="main" type="submit" isLoading={isSubmitting}>Criar manifestação</Button>
            </VStack>
        </Box>
    )
}
export default ComplaintForm